import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=498c6ca8&scoped=true"
import script from "./Configuration.vue?vue&type=script&lang=ts"
export * from "./Configuration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c6ca8",
  null
  
)

export default component.exports